export interface AnimeArticle {
  id: string;
  slug: string;
  title: string;
  titleJa: string;
  category: string;
  categorySlug: string;
  rating: number;
  episodes: string;
  year: number;
  imageSeq: string;
  synopsis: string;
  highlights: string[];
  watchGuide: string;
  characters: { name: string; role: string; description: string }[];
  tags: string[];
  isFeatured: boolean;
  date: string;
}

export interface AnimeCategory {
  slug: string;
  name: string;
  description: string;
  icon: string;
}

export const categories: AnimeCategory[] = [
  { slug: 'mystery', name: '悬疑推理', description: '扣人心弦的悬疑剧情与精妙推理', icon: 'ri-search-eye-line' },
  { slug: 'scifi', name: '科幻奇幻', description: '天马行空的想象力与未来世界', icon: 'ri-rocket-line' },
  { slug: 'psychological', name: '心理惊悚', description: '深入人心的心理刻画与紧张氛围', icon: 'ri-mental-health-line' },
  { slug: 'romance', name: '爱情剧情', description: '细腻动人的情感描写与人性探讨', icon: 'ri-heart-line' },
  { slug: 'action', name: '动作冒险', description: '热血沸腾的战斗场面与冒险旅程', icon: 'ri-sword-line' },
  { slug: 'historical', name: '历史战争', description: '宏大历史背景下的命运交织', icon: 'ri-ancient-gate-line' },
];

export const articles: AnimeArticle[] = [
  {
    id: '1',
    slug: 'death-note',
    title: '死亡笔记',
    titleJa: 'DEATH NOTE',
    category: '悬疑推理',
    categorySlug: 'mystery',
    rating: 9.3,
    episodes: '37集',
    year: 2006,
    imageSeq: 'death-note-anime-poster-dark-atmosphere',
    synopsis: '天才高中生夜神月偶然捡到一本死亡笔记，只要在上面写下对方的名字，对方就会死亡。他化名"基拉"，开始以死亡笔记制裁罪犯，试图创造一个没有犯罪的理想世界。然而，世界顶级侦探L的出现，让这场智慧与正义的较量正式拉开帷幕。这是一部探讨正义、权力与人性的经典之作，以其精妙的心理博弈和深刻的哲学思考征服了全球观众。',
    highlights: [
      '豆瓣9.3分神作，全球公认的悬疑推理巅峰',
      '夜神月与L之间的智斗堪称动画史上最精彩的心理博弈',
      '深刻探讨正义与邪恶的边界，引人深思',
      '剧情节奏紧凑，每一集都扣人心弦',
    ],
    watchGuide: '建议在Bilibili、Netflix等正版平台观看。全37集，建议按顺序完整观看，因为剧情环环相扣，跳看会损失大量精彩细节。推荐给喜欢智斗和悬疑题材的观众。',
    characters: [
      { name: '夜神月', role: '主角', description: '天才高中生，捡到死亡笔记后化名"基拉"，试图以死亡制裁罪犯来创造新世界。' },
      { name: 'L', role: '对手', description: '世界顶级侦探，接受调查基拉案件，拥有极高的智商和独特的推理方式。' },
      { name: '琉克', role: '死神', description: '将死亡笔记丢入人间的死神，对人类的善恶持旁观者态度。' },
    ],
    tags: ['悬疑', '推理', '智斗', '哲学', '高分神作'],
    isFeatured: true,
    date: '2026-07-28',
  },
  {
    id: '2',
    slug: 'attack-on-titan',
    title: '进击的巨人',
    titleJa: '進撃の巨人',
    category: '动作冒险',
    categorySlug: 'action',
    rating: 9.4,
    episodes: '87集（全四季）',
    year: 2013,
    imageSeq: 'attack-on-titan-anime-wall-colossal',
    synopsis: '在一个被巨人支配的世界里，人类被迫生活在巨大的城墙之内。少年艾伦·耶格尔目睹母亲被巨人吞噬后，立誓要消灭所有巨人。随着故事展开，墙外的真相逐渐浮出水面，自由与束缚、正义与复仇的命题贯穿始终。这部作品以其宏大的世界观、震撼的动作场面和层层递进的叙事结构，成为新世纪最具影响力的动漫作品之一。',
    highlights: [
      '豆瓣9.4分，被认为是新世纪最伟大的动漫作品之一',
      '宏大的世界观构建与令人震撼的剧情反转',
      '立体机动装置的战斗画面制作精良，视觉冲击力极强',
      '深刻探讨战争、自由、种族等沉重主题',
    ],
    watchGuide: '全四季共87集，建议在Bilibili观看。第一季奠定世界观，第二季开始揭示真相，第三季分为两部分是剧情的巅峰，最终季将故事推向高潮。务必按顺序观看，不要跳看。',
    characters: [
      { name: '艾伦·耶格尔', role: '主角', description: '调查兵团成员，拥有巨人之力，为追求自由不惜一切代价。' },
      { name: '三笠·阿克曼', role: '战友', description: '艾伦的青梅竹马，阿克曼一族后裔，战斗力极强。' },
      { name: '利威尔·阿克曼', role: '兵长', description: '人类最强士兵，调查兵团特别作战班班长。' },
    ],
    tags: ['动作', '奇幻', '战争', '热血', '史诗'],
    isFeatured: true,
    date: '2026-07-25',
  },
  {
    id: '3',
    slug: 'psycho-pass',
    title: '心理测量者',
    titleJa: 'PSYCHO-PASS サイコパス',
    category: '科幻奇幻',
    categorySlug: 'scifi',
    rating: 8.9,
    episodes: '22集（第一季）',
    year: 2012,
    imageSeq: 'psycho-pass-anime-futuristic-city',
    synopsis: '在近未来的日本，一个名为"西比拉系统"的超级AI通过扫描市民的心理状态来判断其犯罪倾向。公安刑事课的执行官和监视官负责追捕那些心理指数超标的潜在罪犯。新晋监视官常守朱在追捕罪犯的过程中，逐渐发现这个看似完美的系统背后隐藏着令人不寒而栗的真相。这是一部赛博朋克风格的硬核科幻作品，深度探讨了正义、自由意志与社会控制的命题。',
    highlights: [
      '豆瓣8.9分，赛博朋克题材的巅峰之作',
      '虚渊玄编剧，剧情黑暗深刻，反转不断',
      '对"犯罪预防"这一伦理问题的深度探讨',
      '世界观设定严谨，科技细节令人信服',
    ],
    watchGuide: '强烈推荐第一季（22集），是系列公认的最高水准。第二季和剧场版可作为补充观看。在Bilibili有正版资源。适合喜欢硬核科幻和哲学思考的观众。',
    characters: [
      { name: '常守朱', role: '主角', description: '公安刑事课一系监视官，正义感强烈，坚持自己的信念。' },
      { name: '狡啮慎也', role: '执行官', description: '前监视官，因犯罪指数超标被降为执行官，追捕槙岛圣护。' },
      { name: '槙岛圣护', role: '反派', description: '犯罪指数始终正常的特殊存在，西比拉系统无法判定的"免罪体质者"。' },
    ],
    tags: ['科幻', '赛博朋克', '哲学', '犯罪', '硬核'],
    isFeatured: true,
    date: '2026-07-22',
  },
  {
    id: '4',
    slug: 'monster',
    title: 'MONSTER',
    titleJa: 'MONSTER',
    category: '心理惊悚',
    categorySlug: 'psychological',
    rating: 9.2,
    episodes: '74集',
    year: 2004,
    imageSeq: 'monster-anime-dark-thriller-hospital',
    synopsis: '天才脑外科医生天马贤三在德国杜塞尔多夫工作，他违背院长命令为一名头部中枪的男孩约翰进行了手术，救回了他的生命。然而，这个决定引发了一连串骇人听闻的连环杀人事件。天马医生发现，他救回的男孩约翰实际上是一个毫无人性的"怪物"，而他必须踏上追踪约翰的旅途来弥补自己的"错误"。这是一部改编自浦泽直树同名漫画的心理惊悚巨作。',
    highlights: [
      '豆瓣9.2分，浦泽直树漫画改编，被誉为悬疑漫画的金字塔',
      '74集的史诗级叙事，节奏沉稳但张力十足',
      '约翰·李贝特是动漫史上最令人恐惧的反派之一',
      '深刻探讨人性善恶、命运与救赎',
    ],
    watchGuide: '全74集篇幅较长但值得耐心观看。作品节奏较慢，需要静下心来体会。在Bilibili有正版资源。适合喜欢深度心理刻画和悬疑氛围的观众。',
    characters: [
      { name: '天马贤三', role: '主角', description: '日裔德国脑外科医生，善良正直，因救下约翰而踏上追踪之旅。' },
      { name: '约翰·李贝特', role: '反派', description: '被天马救下的男孩，拥有超凡魅力和操控力，被称为"怪物"。' },
      { name: '安娜·李贝特', role: '关键人物', description: '约翰的双胞胎妹妹，是揭开约翰过去的关键。' },
    ],
    tags: ['心理惊悚', '悬疑', '人性', '经典', '漫画改编'],
    isFeatured: true,
    date: '2026-07-20',
  },
  {
    id: '5',
    slug: 'steins-gate',
    title: '命运石之门',
    titleJa: 'Steins;Gate',
    category: '科幻奇幻',
    categorySlug: 'scifi',
    rating: 9.3,
    episodes: '24集',
    year: 2011,
    imageSeq: 'steins-gate-anime-time-travel-lab',
    synopsis: '自称疯狂科学家凤凰院凶真（本名冈部伦太郎）在秋叶原的简陋实验室"未来道具研究所"中，偶然发明了可以向过去发送邮件的时间机器。起初他和伙伴们只是用它来做一些无伤大雅的实验，但很快他们就发现自己卷入了一场关乎世界命运的阴谋之中。作品以"时间旅行"为核心，构建了极其严谨的因果逻辑体系，是硬核科幻与感人剧情完美结合的典范。',
    highlights: [
      '豆瓣9.3分，公认的时间旅行题材巅峰之作',
      '剧情前期铺垫细腻，后期爆发力极强，后半段全程高能',
      '对时间悖论的探讨极其严谨，逻辑自洽',
      '情感刻画深刻，多条故事线交织令人动容',
    ],
    watchGuide: '共24集，前半段（1-12集）为日常铺垫，较为缓慢但绝不可跳过。后半段（13-24集）剧情全面爆发。建议一次性看完以获得最佳体验。在Bilibili有正版资源。',
    characters: [
      { name: '冈部伦太郎', role: '主角', description: '自称"凤凰院凶真"的大学生，未来道具研究所创始人。' },
      { name: '牧濑红莉栖', role: '女主角', description: '天才少女科学家，与冈部共同研究时间机器。' },
      { name: '椎名真由理', role: '青梅竹马', description: '冈部的青梅竹马，天真烂漫，是整个故事的情感核心。' },
    ],
    tags: ['科幻', '时间旅行', '情感', '烧脑', '神作'],
    isFeatured: false,
    date: '2026-07-18',
  },
  {
    id: '6',
    slug: 'nana',
    title: 'NANA',
    titleJa: 'NANA -ナナ-',
    category: '爱情剧情',
    categorySlug: 'romance',
    rating: 9.0,
    episodes: '47集',
    year: 2006,
    imageSeq: 'nana-anime-romance-music-tokyo',
    synopsis: '两个名字相同但性格迥异的女孩——大崎娜娜和小松奈奈，在去往东京的火车上相遇。一个是为了追寻音乐梦想的朋克摇滚歌手，一个是追随男友到东京的单纯女孩。命运让她们成为室友，从此两人的生活紧密交织在一起。这部作品以极其真实细腻的笔触描绘了爱情、友情、梦想与现实之间的碰撞，是女性向动画中不可逾越的经典。',
    highlights: [
      '豆瓣9.0分，矢泽爱漫画改编，女性向动画的标杆之作',
      '对爱情和友情的刻画极其真实，情感冲击力极强',
      '音乐出色，娜娜的朋克摇滚风格独树一帜',
      '两条主线交错叙事，结构精巧',
    ],
    watchGuide: '共47集，建议在Bilibili观看。作品情感浓度极高，建议不要一次性看太多集。原作漫画目前仍在休刊中，动画版提供了一个相对完整的结局。',
    characters: [
      { name: '大崎娜娜', role: '双主角之一', description: '朋克乐队Black Stones主唱，外表冷酷内心温柔。' },
      { name: '小松奈奈', role: '双主角之一', description: '单纯善良的女孩，在爱情中不断成长。' },
      { name: '本城莲', role: '关键人物', description: 'Trapnest乐队吉他手，娜娜的前男友，两人的感情贯穿全剧。' },
    ],
    tags: ['爱情', '音乐', '成长', '女性向', '经典'],
    isFeatured: false,
    date: '2026-07-15',
  },
  {
    id: '7',
    slug: 'code-geass',
    title: '反叛的鲁路修',
    titleJa: 'コードギアス 反逆のルルーシュ',
    category: '动作冒险',
    categorySlug: 'action',
    rating: 9.2,
    episodes: '50集（两季）',
    year: 2006,
    imageSeq: 'code-geass-anime-mecha-battle',
    synopsis: '被神圣不列颠帝国占领的日本（改称11区）中，流亡皇子鲁路修·兰佩洛基意外获得了"绝对命令"的能力Geass。他化身为假面男子Zero，领导黑色骑士团对抗不列颠帝国，同时也要面对青梅竹马枢木朱雀的阻挠。这部作品融合了机甲战斗、政治谋略、校园生活等多种元素，以其出人意料的剧情反转和震撼的结局闻名于世。',
    highlights: [
      '豆瓣9.2分，机甲与智斗完美结合的经典之作',
      '鲁路修是动漫史上最具魅力的主角之一',
      '结局被誉为动漫史上最伟大的结局之一',
      '政治谋略与个人情感的冲突刻画得极为精彩',
    ],
    watchGuide: '共两季50集（R125集+R2 25集），建议按顺序观看。剧场版为平行世界，可在看完TV版后补充观看。在Bilibili有正版资源。',
    characters: [
      { name: '鲁路修·兰佩洛基', role: '主角', description: '不列颠帝国流亡皇子，化名Zero领导反抗组织。' },
      { name: '枢木朱雀', role: '对手/挚友', description: '荣誉不列颠人，鲁路修的青梅竹马，选择从内部改变体制。' },
      { name: 'C.C.', role: '契约者', description: '赋予鲁路修Geass力量的不老不死魔女。' },
    ],
    tags: ['机甲', '智斗', '政治', '热血', '经典结局'],
    isFeatured: false,
    date: '2026-07-12',
  },
  {
    id: '8',
    slug: 'paranoia-agent',
    title: '妄想代理人',
    titleJa: '妄想代理人',
    category: '心理惊悚',
    categorySlug: 'psychological',
    rating: 8.8,
    episodes: '13集',
    year: 2004,
    imageSeq: 'paranoia-agent-anime-surreal-psychological',
    synopsis: '人气角色设计师鹭月子遭遇神秘少年"少年球棒"的袭击后，一系列类似的袭击事件接连发生。警察在追查过程中，发现每起袭击事件之间有着千丝万缕的联系，而真相远比想象中更加离奇。这是今敏导演唯一的TV动画作品，以其超现实主义的叙事手法和对现代人心理困境的深刻洞察，成为心理惊悚题材的代表作。',
    highlights: [
      '豆瓣8.8分，今敏导演唯一TV动画，超现实主义经典',
      '对现代社会集体焦虑与逃避现实的深刻描绘',
      '叙事结构大胆创新，每一集都有独特的表达方式',
      '悬疑氛围营造极为出色，层层递进',
    ],
    watchGuide: '共13集，篇幅精炼。建议一口气看完以获得最佳体验。作品中包含大量象征和隐喻，值得反复观看。在Bilibili有正版资源。',
    characters: [
      { name: '鹭月子', role: '关键人物', description: '人气角色设计师，少年球棒事件的第一个受害者。' },
      { name: '猪狩庆一', role: '主角', description: '负责调查少年球棒事件的刑警，理性沉稳。' },
      { name: '少年球棒', role: '神秘角色', description: '踩着金色轮滑鞋、手持弯曲球棒的谜之少年。' },
    ],
    tags: ['心理惊悚', '超现实', '社会批判', '今敏', '短篇'],
    isFeatured: false,
    date: '2026-07-10',
  },
  {
    id: '9',
    slug: 'vinland-saga',
    title: '冰海战记',
    titleJa: 'ヴィンランド・サガ',
    category: '历史战争',
    categorySlug: 'historical',
    rating: 9.3,
    episodes: '48集（两季）',
    year: 2019,
    imageSeq: 'vinland-saga-anime-viking-epic',
    synopsis: '以11世纪维京时代为背景，讲述了冰岛少年托尔芬为报杀父之仇而追随杀父仇人阿谢拉特的故事。在战火纷飞的欧洲大陆上，托尔芬逐渐从被仇恨驱使的少年成长为追寻真正和平的勇者。这是一部史诗级的历史题材作品，不仅有着宏大的战争场面，更深刻探讨了战争、复仇、和平与人性的主题。',
    highlights: [
      '豆瓣9.3分，WIT STUDIO制作，画面品质极高',
      '基于真实历史改编，维京时代的史诗级还原',
      '从复仇到和平的主题转变极具深度',
      '第二季的农场篇被誉为动漫史上最深刻的人物刻画',
    ],
    watchGuide: '目前两季共48集。第一季以复仇和战争为主线，第二季风格转变为哲学反思。建议两季连续观看，体验主角的完整成长弧线。在Bilibili有正版资源。',
    characters: [
      { name: '托尔芬', role: '主角', description: '冰岛战士之子，为报父仇追随阿谢拉特，后追求真正的和平。' },
      { name: '阿谢拉特', role: '杀父仇人', description: '维京雇佣兵团团长，亦正亦邪，是动漫史上最复杂的角色之一。' },
      { name: '克努特', role: '关键人物', description: '丹麦王子，在阿谢拉特的影响下成长为冷酷的政治家。' },
    ],
    tags: ['历史', '战争', '维京', '成长', '史诗'],
    isFeatured: false,
    date: '2026-07-08',
  },
  {
    id: '10',
    slug: 'erased',
    title: '只有我不存在的城市',
    titleJa: '僕だけがいない街',
    category: '悬疑推理',
    categorySlug: 'mystery',
    rating: 8.9,
    episodes: '12集',
    year: 2016,
    imageSeq: 'erased-anime-time-loop-mystery',
    synopsis: '落魄漫画家藤沼悟拥有一种名为"再上映"的特殊能力，可以在悲剧发生前回到几分钟前的时间点。当他的母亲被谋杀后，他的能力将他送回了18年前的小学时代。他意识到母亲的死与当年发生的一连串儿童绑架杀人案有关，于是开始尝试改变过去，拯救那些本应丧命的孩子们。',
    highlights: [
      '豆瓣8.9分，穿越悬疑题材的精品之作',
      '短短12集体量却有着极强的情感冲击力',
      '对儿童保护这一社会议题的深刻关注',
      '结局感人至深，令人久久回味',
    ],
    watchGuide: '共12集，篇幅紧凑，适合一次性观看。建议准备好纸巾，剧情后半段情感浓度极高。在Bilibili有正版资源。真人版电影与动画版有所不同，建议先看动画。',
    characters: [
      { name: '藤沼悟', role: '主角', description: '拥有"再上映"能力的漫画家，回到过去拯救同学。' },
      { name: '雏月加代', role: '拯救对象', description: '悟的小学同学，长期遭受虐待，是连环绑架案的目标之一。' },
      { name: '片桐爱梨', role: '搭档', description: '现代时间线中相信并帮助悟的女孩。' },
    ],
    tags: ['悬疑', '穿越', '情感', '紧凑', '短篇佳作'],
    isFeatured: false,
    date: '2026-07-05',
  },
  {
    id: '11',
    slug: 'mushishi',
    title: '虫师',
    titleJa: '蟲師',
    category: '科幻奇幻',
    categorySlug: 'scifi',
    rating: 9.4,
    episodes: '26集（第一季）',
    year: 2005,
    imageSeq: 'mushishi-anime-ethereal-nature',
    synopsis: '在一个人与"虫"共存的世界里，"虫"不是我们通常认知的昆虫，而是一种接近生命本源的存在。虫师银古游历于山林乡野之间，研究虫与人类之间发生的各种奇异现象，帮助人们解决由虫引发的困扰。这是一部充满东方哲学韵味的作品，以舒缓的节奏和精美的画面，展现了人与自然和谐共处的美学。',
    highlights: [
      '豆瓣9.4分，独一无二的日式美学巅峰',
      '每一集都是独立的故事，却又和谐统一',
      '画面精美，配乐空灵，沉浸感极强',
      '充满了东方哲学的智慧与禅意',
    ],
    watchGuide: '共26集（第一季），每集独立成篇，可以随时观看。推荐在安静的环境中慢慢品味。作品适合所有年龄段的观众。在Bilibili有正版资源。',
    characters: [
      { name: '银古', role: '主角', description: '一位游历四方的虫师，白发绿眼，对虫有着深刻的了解和敬畏。' },
      { name: '化野', role: '友人', description: '医生，银古的朋友，收藏了许多与虫有关的物品。' },
    ],
    tags: ['奇幻', '治愈', '哲学', '自然', '美学'],
    isFeatured: true,
    date: '2026-07-02',
  },
  {
    id: '12',
    slug: 'shouwa-genroku-rakugo-shinjuu',
    title: '昭和元禄落语心中',
    titleJa: '昭和元禄落語心中',
    category: '历史战争',
    categorySlug: 'historical',
    rating: 9.4,
    episodes: '25集（两季）',
    year: 2016,
    imageSeq: 'rakugo-anime-traditional-japanese-art',
    synopsis: '故事讲述了一位曾有过犯罪经历的青年与太郎，在观看了落语大师八云的演出后被深深打动，决心拜师学艺。随着他深入落语的世界，一段跨越数十年的师徒传承、嫉妒、赎罪与爱的故事缓缓展开。作品以日本传统艺术"落语"为载体，描绘了昭和时代到平成时代近一个世纪的社会变迁与人性百态。',
    highlights: [
      '豆瓣9.4分，被誉为"动画中的艺术品"',
      '对日本传统落语文化的精彩呈现与传承',
      '跨越数十年的宏大叙事，人物命运令人唏嘘',
      '声优表演堪称教科书级别',
    ],
    watchGuide: '共两季25集。第一季（13集）讲述过去的故事，第二季（12集）延续至现代。建议先了解落语的基本概念以更好地理解剧情。在Bilibili有正版资源。',
    characters: [
      { name: '与太郎', role: '主角', description: '前科犯，被落语吸引后拜八云为师，天性乐观开朗。' },
      { name: '有乐亭八云', role: '师父', description: '落语界最后的大师，一生被过去所困，与太郎的出现改变了他的生活。' },
      { name: '助六', role: '故人', description: '八云已故的挚友和竞争对手，两人之间的羁绊贯穿全剧。' },
    ],
    tags: ['历史', '传统文化', '落语', '人性', '文艺'],
    isFeatured: true,
    date: '2026-06-30',
  },
];

export const faqData = [
  {
    question: '什么是"成人动漫"？它和普通动漫有什么区别？',
    answer: '成人动漫是指面向成年观众制作的动漫作品，通常包含更复杂的叙事结构、更深刻的主题探讨和更成熟的表现手法。与面向青少年的一般动漫相比，成人动漫在剧情深度、人物刻画和思想内涵上更为丰富，可能涉及暴力、哲学、社会批判等成人化主题。',
  },
  {
    question: '成人动漫一定包含不适宜内容吗？',
    answer: '不一定。成人动漫的"成人"指的是目标观众群体为成年人，而非内容上的限制级。许多成人动漫作品完全没有不适宜内容，而是通过深刻的主题、复杂的剧情和独特的美学来吸引成年观众。本网站推荐的作品均为制作精良、艺术价值高的作品。',
  },
  {
    question: '如何选择适合自己的成人动漫？',
    answer: '可以从你喜欢的类型入手。如果你喜欢悬疑推理，可以尝试《死亡笔记》或《MONSTER》；喜欢科幻题材，《命运石之门》和《心理测量者》是不错的选择；偏爱情感剧情，《NANA》值得一看。你也可以通过本网站的分类导航来筛选感兴趣的题材。',
  },
  {
    question: '在哪里可以观看这些成人动漫作品？',
    answer: '大部分作品可以在Bilibili、Netflix等正规流媒体平台观看。我们建议通过正版渠道支持创作者。每部作品的详情页中都包含了具体的观看指南，请参考各作品的详细信息。',
  },
  {
    question: '你们的推荐标准是什么？',
    answer: '我们的推荐标准包括：作品的整体品质（制作水平、叙事能力）、观众口碑（各平台评分）、艺术价值（主题深度、表现手法）以及作品的影响力。我们力求推荐真正值得一看的优质作品，而非盲目追求热门。',
  },
  {
    question: '网站推荐的作品是否定期更新？',
    answer: '是的，我们会持续关注优秀的成人动漫新作，并定期更新推荐列表。同时也会回顾一些经典老作，为新观众提供更多选择。建议定期访问我们的网站获取最新推荐。',
  },
];